import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using React Bootstrap for modals

const ViewPaymentPlanModal = ({ show, handleClose, paymentplan }) => {
    if (!paymentplan) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Payment Plan Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>ID:</strong> {paymentplan.id}
                </div>
                <div className='mb-3'>
                    <strong>Nickname:</strong> {paymentplan.name}
                </div>
                <div className="mb-3">
                    <strong>Installments:</strong> {paymentplan.installments}
                </div>
                <div className="mb-3">
                    <strong>Downpayment:</strong> {paymentplan.downpayment}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewPaymentPlanModal;
